let apiURL = (process.env.REACT_APP_BASE_API_URL || '/edition/api');

export const setApiUrl = (host) => {
    apiURL = host
}

export const getApiUrl = () => {
    return apiURL;
}

export const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID;
export const gaDebug = process.env.REACT_APP_GA_DEBUG === "true";
export const googleTagManagerId = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const BASE_URL = process.env.REACT_APP_BASE_URL;



// WEBPACK FOOTER //
// ./src/config.js